<script lang="ts">
    import { cn } from "@/lib/utils";

    export let href: string
    let className = 'text-sm'
    export {className as class}
    export let containerClass = undefined
</script>

<a class={containerClass} {href} target='_help'>
    <i class={cn("fa-light fa-circle-question", className)}/>
    <span class="ml-0.5"><slot /></span>    
</a>
